import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fallback_loose_chance~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_fallback_loose_chance'),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_fallback_loose_chance~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_fallback_loose_chance'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_fallback_loose_chance~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_fallback_loose_chance'),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_fallback_loose_chance~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_fallback_loose_chance'),
			},
		},
	},
]

export default config
